import { DiagramShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/DiagramShape';
import { BEComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComponent';
import { NodeShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/NodeShape';
import { ShapeService } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/ShapeService';
import { ShapeElement } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/ShapeElement';
import { LineShape } from '../../../../../../api/com/MetaPattern/MDA/Designer/Shape/LineShape';
import { BEEntity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEntity';
import { BEComment } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEComment';
import { BEInterface } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEInterface';
import { EntityGeneration } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EntityGeneration';
import { InterfaceGeneration } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/InterfaceGeneration';
import { JointShapeRepository } from './JointShapeRepository';
import { Implement } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Implement';
import { Association } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Association';
import { BEEnum } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEEnum';
import { Composition } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Composition';
import { Aggregation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/Aggregation';
import { CrossAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/CrossAssociation';
import { DependencyAssociation } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/DependencyAssociation';
import { BEBusinessLogic } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEBusinessLogic';
import { BEDTO } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDTO';
import { BEService } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEService';
import { BEConstant } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEConstant';
import { EnumComponentType } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/EnumComponentType';
import { BaseComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { APPComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComponent';
import { MDExtendService } from '../../MD/MDExtendService';
import { MenuSet } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuSet';
import { MenuContain } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/MenuContain';
import { ConfigGroup } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/ConfigGroup';
import { BEExternalService } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEExternalService';
import { BEDistributedTransaction } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEDistributedTransaction';
import { MDShape } from '../BaseShape/MDShape';
import { BaseElement } from '../../../../../../api/com/MetaPattern/MDA/MD/Base/BaseElement';
import { ValidationResult } from '../../../../../../api/com/MetaPattern/Core/Infrastructure/Common/ValidationResult';
import { EnumDisplayLanguage } from '../../../../../../api/com/MetaPattern/MDA/Designer/Base/EnumDisplayLanguage';
import { BEValueObject } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEValueObject';
import { JointCommentShape } from './Shape/JointCommentShape';
import { JointEntityShape } from './Shape/JointEntityShape';
import { JointBusinessLogicShape } from './Shape/JointBusinessLogicShape';
import { JointConfigGroupShape } from './Shape/JointConfigGroupShape';
import { JointConstantShape } from './Shape/JointConstantShape';
import { JointDistributedTransactionShape } from './Shape/JointDistributedTransactionShape';
import { JointDTOShape } from './Shape/JointDTOShape';
import { JointEnumShape } from './Shape/JointEnumShape';
import { JointExternalServiceShape } from './Shape/JointExternalServiceShape';
import { JointInterfaceShape } from './Shape/JointInterfaceShape';
import { JointMenuSetShape } from './Shape/JointMenuSetShape';
import { JointServiceShape } from './Shape/JointServiceShape';
import { JointValueObjectShape } from './Shape/JointValueObjectShape';
import { JointAggregationLink } from './Link/JointAggregationLink';
import { JointAssociationLink } from './Link/JointAssociationLink';
import { JointCompositionLink } from './Link/JointCompositionLink';
import { JointCrossLink } from './Link/JointCrossLink';
import { JointDependencyAssociationLink } from './Link/JointDependencyAssociationLink';
import { JointGenerationLink } from './Link/JointGenerationLink';
import { JointImplementLink } from './Link/JointImplementLink';
import { JointMenuContainLink } from './Link/JointMenuContainLink';
import { RelationshipLink } from '../BaseShape/RelationshipLink';
import { MDBaseShape } from '../BaseShape/MDBaseShape';
import { APPComment } from '../../../../../../api/com/MetaPattern/MDA/MD/APPModel/APPComment';
import { ProductComponent } from '../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComponent';
import { ProductComment } from '../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductComment';
import { ProductAPP } from '../../../../../../api/com/MetaPattern/MDA/MD/ProductModel/ProductAPP';
import { JointProductAPPShape } from './Shape/JointProductAPPShape';
import { MDValidation } from '../../MD/MDValidation';
import { JointReferenceEntityShape } from './Shape/JointReferenceEntityShape';
import { BEReferenceEntity } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/BEReferenceEntity';
import { EnumEntityStructureType } from '../../../../../../api/com/MetaPattern/MDA/MD/EntityModel/EnumEntityStructureType';

export class Diagram implements MDShape {
  private _id: string;
  private _diagramShape: DiagramShape;
  private _component: BaseComponent;
  private _hasChanged: boolean; // 图表及内部元素是否发生了修改，修改后需要保存文件
  private _cells: Array<any>; // 前端图形
  private _isSelected: boolean; // 当前是否被选择/激活
  private _isLock: boolean; // 是否锁定，锁定的元素不能修改，但是可以改变位置，可以选中

  private constructor() {
    // 私有构造器，防止实例化
    this._hasChanged = false;
    this._isSelected = false;
    this._cells = new Array<any>();
  }

  /** 是否修改，图表或元数据发生修改都认定为已经修改 */
  get isModified(): boolean {
    return this._hasChanged;
  }

  /** 是否修改，图表或元数据发生修改都认定为已经修改 */
  set isModified(value: boolean) {
    this._hasChanged = value;
  }

  get id(): string {
    return this._id;
  }

  set id(value: string) {
    this._id = value;
  }

  get component(): BaseComponent {
    return this._component;
  }

  set component(value: BaseComponent) {
    this._component = value;
  }

  get diagramShape(): DiagramShape {
    return this._diagramShape;
  }

  set diagramShape(value: DiagramShape) {
    this._diagramShape = value;
  }

  /**
   * 所有修改已经保存
   */
  saved() {
    this._hasChanged = false;
  }

  /**
   * 创建新的图文件
   * @param component 组件
   */
  static create(component: BaseComponent): Diagram {
    const diagram = new Diagram();
    diagram._component = component;
    diagram._id = component.designId;
    diagram._hasChanged = true;

    diagram.init();
    // const _diagramShape = JointShapeRepository.createDiagramShape(component);
    // diagram._diagramShape = _diagramShape;

    return diagram;
  }

  /**
   * 加载图文件
   * @param componentId 组件的ID，不存在则返回null
   * @param componentType 组件类型
   */
  static async loadAsync(componentId: string, componentType: EnumComponentType): Promise<Diagram | null> {
    return new Promise((resolve, reject) => {
      const diagram = new Diagram();
      const diagramPromise = ShapeService.GetFullDiagramAsync(componentId);
      const componentPromise = MDExtendService.GetFullComponentAsync(componentId, componentType);
      Promise.all([diagramPromise, componentPromise])
        .then((results: [DiagramShape, BaseComponent]) => {
          diagram._diagramShape = results[0];
          diagram._component = results[1];
          if (results[1]) {
            diagram._id = results[1].designId;
          }
          diagram.init();
          resolve(diagram);
        })
        .catch((error: any) => {
          console.log('Diagram loadAsync has error : ' + error);
          reject(error);
        });
    });
  }

  /** 获取所有的前端图形，创建前端图形的时候需要加入到此集合 */
  get cells() {
    return this._cells;
  }

  /** 删除一个图形，包括Diagram内部的元数据和图形元数据 */
  deleteCell(cell: any) {
    if (cell instanceof MDBaseShape) {
      const findShapeIndex = this.diagramShape.nodeShapes.findIndex(item => item.designId === cell.shape().designId);
      if (findShapeIndex >= 0) {
        this.diagramShape.nodeShapes.splice(findShapeIndex, 1);
      }
      if (cell instanceof JointCommentShape) {
        if (this.component instanceof BEComponent || this.component instanceof APPComponent || this.component instanceof ProductComponent) {
          const findElementIndex = this.component.comments.findIndex((item: BaseElement) => item.designId === cell.element().designId);
          if (findElementIndex >= 0) {
            this.component.comments.splice(findElementIndex, 1);
          }
        }
      } else if (cell instanceof JointEntityShape) {
        const findElementIndex = (this.component as BEComponent).entities.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).entities.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointEnumShape) {
        const findElementIndex = (this.component as BEComponent).enums.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).enums.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointBusinessLogicShape) {
        const findElementIndex = (this.component as BEComponent).businessLogics.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).businessLogics.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointConstantShape) {
        const findElementIndex = (this.component as BEComponent).constants.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).constants.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointInterfaceShape) {
        const findElementIndex = (this.component as BEComponent).interfaces.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).interfaces.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointDistributedTransactionShape) {
        const findElementIndex = (this.component as BEComponent).distributedTransactions.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).distributedTransactions.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointDTOShape) {
        const findElementIndex = (this.component as BEComponent).dTOes.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).dTOes.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointReferenceEntityShape) {
        const findElementIndex = (this.component as BEComponent).referenceEntities.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).referenceEntities.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointServiceShape) {
        const findElementIndex = (this.component as BEComponent).services.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).services.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointExternalServiceShape) {
        const findElementIndex = (this.component as BEComponent).externalServices.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).externalServices.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointValueObjectShape) {
        const findElementIndex = (this.component as BEComponent).valueObjects.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).valueObjects.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointConfigGroupShape) {
        const findElementIndex = (this.component as APPComponent).configGroups.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as APPComponent).configGroups.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointMenuSetShape) {
        const findElementIndex = (this.component as APPComponent).menuSets.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as APPComponent).menuSets.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointProductAPPShape) {
        const findElementIndex = (this.component as ProductComponent).productAPPs.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as ProductComponent).productAPPs.splice(findElementIndex, 1);
        }
      }
    } else if (cell instanceof RelationshipLink) {
      const findShapeIndex = this.diagramShape.lineShapes.findIndex(item => item.designId === cell.shape().designId);
      if (findShapeIndex >= 0) {
        this.diagramShape.lineShapes.splice(findShapeIndex, 1);
      }
      if (cell instanceof JointAggregationLink) {
        const findElementIndex = (this.component as BEComponent).aggregations.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).aggregations.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointAssociationLink) {
        const findElementIndex = (this.component as BEComponent).associations.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).associations.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointCompositionLink) {
        const findElementIndex = (this.component as BEComponent).compositions.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).compositions.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointCrossLink) {
        const findElementIndex = (this.component as BEComponent).crossAssociations.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).crossAssociations.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointDependencyAssociationLink) {
        const findElementIndex = (this.component as BEComponent).dependencyAssociations.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).dependencyAssociations.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointGenerationLink) {
        let findElementIndex = (this.component as BEComponent).entityGenerations.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).entityGenerations.splice(findElementIndex, 1);
        } else {
          findElementIndex = (this.component as BEComponent).interfaceGenerations.findIndex(item => item.designId === cell.element().designId);
          if (findElementIndex >= 0) {
            (this.component as BEComponent).interfaceGenerations.splice(findElementIndex, 1);
          }
        }
      } else if (cell instanceof JointImplementLink) {
        const findElementIndex = (this.component as BEComponent).implements.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as BEComponent).implements.splice(findElementIndex, 1);
        }
      } else if (cell instanceof JointMenuContainLink) {
        const findElementIndex = (this.component as APPComponent).menuContains.findIndex(item => item.designId === cell.element().designId);
        if (findElementIndex >= 0) {
          (this.component as APPComponent).menuContains.splice(findElementIndex, 1);
        }
      }
    }
    this._cells.splice(this._cells.indexOf(cell), 1);
  }

  /** 获取所有的图形元数据 */
  get shapeElements(): Array<ShapeElement> {
    const shapeElements = new Array<ShapeElement>();

    if (this._diagramShape) {
      this._diagramShape.nodeShapes.forEach((nodeShape: NodeShape) => {
        shapeElements.push(nodeShape);
      });
      this._diagramShape.lineShapes.forEach((lineShape: LineShape) => {
        shapeElements.push(lineShape);
      });
    }
    return shapeElements;
  }

  /** 初始化：将元数据转化为Joint的图形 */
  private init() {
    // 如果没有元素，则是丢失了图形，需要自动创建
    if (this._cells.length === 0) {
      if (!this._diagramShape) {
        this._diagramShape = JointShapeRepository.createDiagramShape(this._component);
        if (this._component instanceof BEComponent) {
          this.createBEComponentDiagram(this._component as BEComponent);
        } else if (this._component instanceof APPComponent) {
          this.createAPPComponentDiagram(this._component as APPComponent);
        } else if (this._component instanceof ProductComponent) {
          this.createProductComponentDiagram(this._component as ProductComponent);
        }
      } else {
        if (this._component instanceof BEComponent) {
          this.buildBEComponentDiagram(this._component as BEComponent);
        } else if (this._component instanceof APPComponent) {
          this.buildAPPComponentDiagram(this._component as APPComponent);
        } else if (this._component instanceof ProductComponent) {
          this.buildProductComponentDiagram(this._component as ProductComponent);
        }
      }
    }
  }

  /**
   * 创建Product组件的图形
   * @param productComponent Product组件
   */
  private createProductComponentDiagram(productComponent: ProductComponent) {
    let x = 20;
    let y = 20;
    productComponent.comments.forEach((comment: ProductComment) => {
      this._cells.push(JointShapeRepository.createProductCommentShape(this, comment, null, x, y));
      x += 300;
    });
    if (x > 20) y += 200;
    productComponent.productAPPs.forEach((productAPP: ProductAPP) => {
      this._cells.push(JointShapeRepository.createProductAPPShape(this, productAPP, null, x, y));
      x += 300;
    });
  }

  /**
   * 创建APP组件的图形
   * @param appComponent APP组件
   */
  private createAPPComponentDiagram(appComponent: APPComponent) {
    let x = 20;
    let y = 20;
    appComponent.comments.forEach((comment: APPComment) => {
      this._cells.push(JointShapeRepository.createAPPCommentShape(this, comment, null, x, y));
      x += 300;
    });
    if (x > 20) y += 200;
    appComponent.menuSets.forEach((menuSet: MenuSet) => {
      this._cells.push(JointShapeRepository.createMenuSetShape(this, menuSet, null, x, y));
      x += 300;
    });
    if (x > 20) y += 200;
    x = 20;
    appComponent.configGroups.forEach((configGroup: ConfigGroup) => {
      this._cells.push(JointShapeRepository.createConfigGroupShape(this, configGroup, null, x, y));
      x += 300;
    });
    // 关系：菜单主子关系
    appComponent.menuContains.forEach((menuContain: MenuContain) => {
      const source = this._cells.find((item) => item.element().id === menuContain.mainMenuSet_ID);
      const target = this._cells.find((item) => item.element().id === menuContain.subMenuSet_ID);
      this._cells.push(JointShapeRepository.createMenuContainLink(this, null, menuContain, source, target));
    });
  }

  /**
   * 构造Product组件的图形
   * @param productComponent Product组件
   */
  private buildProductComponentDiagram(productComponent: ProductComponent) {
    this._diagramShape.nodeShapes.forEach((nodeShape: NodeShape) => {
      if (nodeShape.elementType === 'ProductComment') {
        const comment = productComponent.comments.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createProductCommentShape(this, comment, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      }
      if (nodeShape.elementType === 'ProductAPP') {
        const productAPP = productComponent.productAPPs.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createProductAPPShape(this, productAPP, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      }
    });
  }

  /**
   * 构造APP组件的图形
   * @param appComponent APP组件
   */
  private buildAPPComponentDiagram(appComponent: APPComponent) {
    this._diagramShape.nodeShapes.forEach((nodeShape: NodeShape) => {
      if (nodeShape.elementType === 'APPComment') {
        const comment = appComponent.comments.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createAPPCommentShape(this, comment, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      }
      if (nodeShape.elementType === 'MenuSet') {
        const menuSet = appComponent.menuSets.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createMenuSetShape(this, menuSet, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      }
      if (nodeShape.elementType === 'ConfigGroup') {
        const configGroup = appComponent.configGroups.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createConfigGroupShape(this, configGroup, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      }
    });
    this._diagramShape.lineShapes.forEach((lineShape: LineShape) => {
      if (lineShape.relationshipType === 'MenuContain') {
        const relationship = appComponent.menuContains.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.mainMenuSet_ID);
        const target = this._cells.find((item) => item.element().id === relationship.subMenuSet_ID);
        this._cells.push(JointShapeRepository.createMenuContainLink(this, lineShape, relationship, source, target));
      }
    });
  }

  /**
   * 构造BE组件的图形
   * @param beComponent BE组件
   */
  private buildBEComponentDiagram(bEComponent: BEComponent) {
    this._diagramShape.nodeShapes.forEach((nodeShape: NodeShape) => {
      if (nodeShape.elementType === 'BEEntity') {
        const entity = bEComponent.entities.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createEntityShape(this, entity, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEComment') {
        const comment = bEComponent.comments.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createBECommentShape(this, comment, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEInterface') {
        const bEInterface = bEComponent.interfaces.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createInterfaceShape(this, bEInterface, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEEnum') {
        const bEEnum = bEComponent.enums.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createEnumShape(this, bEEnum, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEService') {
        const service = bEComponent.services.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createServiceShape(this, service, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEBusinessLogic') {
        const bEBusinessLogic = bEComponent.businessLogics.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createBusinessLogicShape(this, bEBusinessLogic, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEDTO') {
        const dto = bEComponent.dTOes.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createDTOShape(this, dto, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEValueObject') {
        const valueObject = bEComponent.valueObjects.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createValueObjectShape(this, valueObject, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEConstant') {
        const constant = bEComponent.constants.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createConstantShape(this, constant, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEExternalService') {
        const externalService = bEComponent.externalServices.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createExternalServiceShape(this, externalService, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEDistributedTransaction') {
        const distributedTransaction = bEComponent.distributedTransactions.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createDistributedTransactionShape(this, distributedTransaction, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      } else if (nodeShape.elementType === 'BEReferenceEntity') {
        const referenceEntity = bEComponent.referenceEntities.find((item) => item.designId === nodeShape.elementId);
        this._cells.push(JointShapeRepository.createReferenceEntityShape(this, referenceEntity, nodeShape, nodeShape.startPoint.x, nodeShape.startPoint.y));
      }
    });
    this._diagramShape.lineShapes.forEach((lineShape: LineShape) => {
      if (lineShape.relationshipType === 'EntityGeneration') {
        const relationship = bEComponent.entityGenerations.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.subEntity_ID);
        const target = this._cells.find((item) => item.element().id === relationship.superEntity_ID);
        this._cells.push(JointShapeRepository.createGenerationLink(this, lineShape, relationship, null, source, target));
      } else if (lineShape.relationshipType === 'InterfaceGeneration') {
        const relationship = bEComponent.interfaceGenerations.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.subInterface_ID);
        const target = this._cells.find((item) => item.element().id === relationship.superInterface_ID);
        this._cells.push(JointShapeRepository.createGenerationLink(this, lineShape, null, relationship, source, target));
      } else if (lineShape.relationshipType === 'implement') {
        const relationship = bEComponent.implements.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.entity_ID);
        const target = this._cells.find((item) => item.element().id === relationship.interface_ID);
        this._cells.push(JointShapeRepository.createImplementLink(this, lineShape, relationship, source, target));
      } else if (lineShape.relationshipType === 'association') {
        const relationship = bEComponent.associations.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.sourceEntity_ID);
        const target = this._cells.find((item) => item.element().id === relationship.targetEntity_ID);
        this._cells.push(JointShapeRepository.createAssociationLink(this, lineShape, relationship, source, target));
      } else if (lineShape.relationshipType === 'dependency') {
        const relationship = bEComponent.dependencyAssociations.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.sourceEntity_ID);
        const target = this._cells.find((item) => item.element().id === relationship.targetEntity_ID);
        this._cells.push(JointShapeRepository.createDependencyLink(this, lineShape, relationship, source, target));
      } else if (lineShape.relationshipType === 'composition') {
        const relationship = bEComponent.compositions.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.sourceEntity_ID);
        const target = this._cells.find((item) => item.element().id === relationship.targetEntity_ID);
        this._cells.push(JointShapeRepository.createCompositionLink(this, lineShape, relationship, source, target));
      } else if (lineShape.relationshipType === 'aggregation') {
        const relationship = bEComponent.aggregations.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.sourceEntity_ID);
        const target = this._cells.find((item) => item.element().id === relationship.targetEntity_ID);
        this._cells.push(JointShapeRepository.createAggregationLink(this, lineShape, relationship, source, target));
      } else if (lineShape.relationshipType === 'cross') {
        const relationship = bEComponent.crossAssociations.find((item) => item.designId === lineShape.relationshipId);
        const source = this._cells.find((item) => item.element().id === relationship.sourceEntity_ID);
        const target = this._cells.find((item) => item.element().id === relationship.targetEntity_ID);
        this._cells.push(JointShapeRepository.createCrossLink(this, lineShape, relationship, source, target));
      }
    });
  }

  /**
   * 创建BE组件的图形
   * @param bEComponent BE组件
   */
  private createBEComponentDiagram(bEComponent: BEComponent) {
    let x = 20;
    let y = 20;
    bEComponent.comments.forEach((comment: BEComment) => {
      this._cells.push(JointShapeRepository.createBECommentShape(this, comment, null, x, y));
      x += 300;
    });
    if (x > 20) y += 100;
    x = 20;
    bEComponent.enums.forEach((bEEnum: BEEnum) => {
      this._cells.push(JointShapeRepository.createEnumShape(this, bEEnum, null, x, y));
      x += 200;
    });
    bEComponent.valueObjects.forEach((valueObject: BEValueObject) => {
      this._cells.push(JointShapeRepository.createValueObjectShape(this, valueObject, null, x, y));
      x += 200;
    });
    if (x > 20) y += 200;
    x = 20;
    bEComponent.constants.forEach((constant: BEConstant) => {
      this._cells.push(JointShapeRepository.createConstantShape(this, constant, null, x, y));
      x += 200;
    });
    if (x > 20) y += 200;
    x = 20;
    bEComponent.interfaces.forEach((bEInterface: BEInterface) => {
      this._cells.push(JointShapeRepository.createInterfaceShape(this, bEInterface, null, x, y));
      x += 200;
    });
    if (x > 20) y += 200;
    x = 20;
    bEComponent.entities.forEach((entity: BEEntity) => {
      this._cells.push(JointShapeRepository.createEntityShape(this, entity, null, x, y));
      x += 200;
    });
    bEComponent.referenceEntities.forEach((referenceEntity: BEReferenceEntity) => {
      this._cells.push(JointShapeRepository.createReferenceEntityShape(this, referenceEntity, null, x, y));
      x += 200;
    });
    if (x > 20) y += 200;
    x = 20;
    bEComponent.services.forEach((service: BEService) => {
      this._cells.push(JointShapeRepository.createServiceShape(this, service, null, x, y));
      x += 200;
    });
    bEComponent.distributedTransactions.forEach((distributedTransaction: BEDistributedTransaction) => {
      this._cells.push(JointShapeRepository.createDistributedTransactionShape(this, distributedTransaction, null, x, y));
      x += 200;
    });
    if (x > 20) y += 200;
    x = 20;
    bEComponent.businessLogics.forEach((businessLogic: BEBusinessLogic) => {
      this._cells.push(JointShapeRepository.createBusinessLogicShape(this, businessLogic, null, x, y));
      x += 200;
    });
    bEComponent.externalServices.forEach((externalService: BEExternalService) => {
      this._cells.push(JointShapeRepository.createExternalServiceShape(this, externalService, null, x, y));
      x += 200;
    });
    bEComponent.dTOes.forEach((dto: BEDTO) => {
      this._cells.push(JointShapeRepository.createDTOShape(this, dto, null, x, y));
      x += 200;
    });
    // 关系：实体继承
    bEComponent.entityGenerations.forEach((entityGeneration: EntityGeneration) => {
      const source = this._cells.find((item) => item.element().id === entityGeneration.subEntity_ID);
      const target = this._cells.find((item) => item.element().id === entityGeneration.superEntity_ID);
      this._cells.push(JointShapeRepository.createGenerationLink(this, null, entityGeneration, null, source, target));
    });
    // 关系：接口继承
    bEComponent.interfaceGenerations.forEach((interfaceGeneration: InterfaceGeneration) => {
      const source = this._cells.find((item) => item.element().id === interfaceGeneration.subInterface_ID);
      const target = this._cells.find((item) => item.element().id === interfaceGeneration.superInterface_ID);
      this._cells.push(JointShapeRepository.createGenerationLink(this, null, null, interfaceGeneration, source, target));
    });
    // 关系：实体实现接口
    bEComponent.implements.forEach((implement: Implement) => {
      const source = this._cells.find((item) => item.element().id === implement.entity_ID);
      const target = this._cells.find((item) => item.element().id === implement.interface_ID);
      this._cells.push(JointShapeRepository.createImplementLink(this, null, implement, source, target));
    });
    // 关系：关联关系
    bEComponent.associations.forEach((association: Association) => {
      const source = this._cells.find((item) => item.element().id === association.sourceEntity_ID);
      const target = this._cells.find((item) => item.element().id === association.targetEntity_ID);
      this._cells.push(JointShapeRepository.createAssociationLink(this, null, association, source, target));
    });
    // 关系：依赖关联关系
    bEComponent.dependencyAssociations.forEach((dependency: DependencyAssociation) => {
      const source = this._cells.find((item) => item.element().id === dependency.sourceEntity_ID);
      const target = this._cells.find((item) => item.element().id === dependency.targetEntity_ID);
      this._cells.push(JointShapeRepository.createDependencyLink(this, null, dependency, source, target));
    });
    // 关系：组合关系
    bEComponent.compositions.forEach((composition: Composition) => {
      const source = this._cells.find((item) => item.element().id === composition.sourceEntity_ID);
      const target = this._cells.find((item) => item.element().id === composition.targetEntity_ID);
      this._cells.push(JointShapeRepository.createCompositionLink(this, null, composition, source, target));
    });
    // 关系：聚合关系
    bEComponent.aggregations.forEach((aggregation: Aggregation) => {
      const source = this._cells.find((item) => item.element().id === aggregation.sourceEntity_ID);
      const target = this._cells.find((item) => item.element().id === aggregation.targetEntity_ID);
      this._cells.push(JointShapeRepository.createAggregationLink(this, null, aggregation, source, target));
    });
    // 关系：交叉关联关系
    bEComponent.crossAssociations.forEach((cross: CrossAssociation) => {
      const source = this._cells.find((item) => item.element().id === cross.sourceEntity_ID);
      const target = this._cells.find((item) => item.element().id === cross.targetEntity_ID);
      this._cells.push(JointShapeRepository.createCrossLink(this, null, cross, source, target));
    });
  }

  // -------------接口实现

  public shapeType(): string {
    return 'diagram';
  }

  public element(): BaseElement {
    return this._component;
  }

  /** 图形包含的子元素的集合 */
  childElements(): Array<BaseElement> {
    const elements = new Array<BaseElement>();
    this.cells.forEach(cell => elements.push(...cell.childElements()));
    return elements;
  }

  public shape(): ShapeElement {
    return this._diagramShape;
  }

  public toMD(): void {
    this.cells.forEach((cell: MDShape) => {
      cell.toMD();
    });
  }

  public fromMD(): void {
    this.cells.forEach((cell: MDShape) => {
      cell.fromMD();
    });
  }

  /** 当前图形是否被选中 */
  isSelect(): boolean {
    return this._isSelected;
  }

  public select(): string {
    this._isSelected = true;
    return this._component.designId;
  }

  public unSelect(): string {
    this._isSelected = false;
    return this._component.designId;
  }

  /** 是否锁定，锁定的元素，不能进行修改操作 */
  isLock(): boolean {
    return this._isLock;
  }

  /** 锁定图形 */
  lock(): void {
    this._isLock = true;
  }

  /** 解锁图形 */
  unLock(): void {
    this._isLock = false;
  }

  /** 克隆图形，包括图形内部所有元素，不包括与其他图形的关系 */
  public cloneShape(): MDShape {
    return null;
  }

  /**
   * 组件的校验器，检验旗下所有的元素
   */
  public validate(): Array<ValidationResult> {
    const errors = new Array<ValidationResult>();
    const componentDesignId = this._component.designId;
    this._cells.forEach((cell: MDShape) => {
      const results = cell.validate();
      results.forEach((result) => {
        errors.push(result);
      });
    });
    if (this.component instanceof ProductComponent) {
      MDValidation.validateProductComponent(this.component, errors);
    } else if (this.component instanceof APPComponent) {
      MDValidation.validateAPPComponent(this.component, errors);
    } else if (this.component instanceof BEComponent) {
      MDValidation.validateBEComponent(this.component, errors);
    }
    return errors;
  }

  /**
   * 设置显示语言
   * @param displayLanguage 显示语言
   */
  setDisplayLanguage (displayLanguage: EnumDisplayLanguage) {
    // 设置旗下所有图形的显示语言
    this._cells.forEach((cell: MDShape) => {
      cell.setDisplayLanguage(displayLanguage);
    });
  }

  public refresh(): void {
    // do nothing
  }
}
